<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/logo.png"
                alt="login"
                class="mx-auto login-img butterfly-logo"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <div>
                  <!--<vs-input
                    name="mobileNo"
                    icon-no-border
                    icon="icon icon-phone"
                    icon-pack="feather"
                    label-placeholder="Mobile No"
                    v-model="mobileNo"
                    class="w-full"
                  />-->
                  <vs-input
                    type="tel"
                    v-validate="'required|min:11|max:11'"
                    data-vv-validate-on="blur"
                    label-placeholder="Mobile No"
                    name="mobileNo"
                    placeholder="Use 11 digit mobile number"
                    v-model="mobileNo"
                    @keypress="onlyNumber"
                    class="w-full"/>
                  <span class="text-danger text-sm"  v-show="errors.has('mobileNo')">{{ errors.first('mobileNo') }}</span>

                  <!--<vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                  />-->
                  <vs-input
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6|max:10'"
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    @keydown.enter.prevent="loginUser"
                    class="w-full mt-6"/>
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                    <router-link to="/pages/forgot-password">Forgot Password?</router-link>
                  </div>
                  <div class="flex flex-wrap justify-between mb-3">
                    <router-link class="mt-2" to="/pages/register">New Applicant Registration</router-link>
                    <!--<vs-button type="border" @click="registerUser">New Applicant Registration</vs-button>-->
                    <vs-button :disabled="!validateForm" @click="loginUser" color="rgb(0 121 193)" id="button-with-loading"
                               class="vs-con-loading__container" type="relief">Login
                    </vs-button>
                  </div>
                  <!--<div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                    <router-link to="/pages/forgot-password">Forgot Password?</router-link>
                  </div>
                  <vs-button  type="border" @click="registerUser">Register</vs-button>
                  <vs-button class="float-right" @click="loginUser">Login</vs-button>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import login from '../../graphql/Login.gql'
import {onLogin} from '../../vue-apollo'
import gql from 'graphql-tag'
const meQuery = gql`
  query me {
    me{
      id
      phone
      name
      ekyc{
      status
        parsonal{
          id
          name
          father_name
          mother_name
          spouse_name
          age
          marital_status
          gender
          head_of_household
          education_level
          nid
          nid_front
          nid_back
          photo
        }
      }
   }
}`
export default {
  data () {
    return {
      mobileNo: '',
      password: '',
      checkbox_remember_me: false,
      msg: '',
      loading: false
    }
  },
  apollo: {
    me: {
      query: meQuery
    }
  },
  mounted () {
    console.log('Me : ', this.me)
    if (this.me !== null && this.me !== undefined) {
      //this.$router.push('/applicantDashboard').catch(() => {});
    }
  },
  created () {
    console.log('Me created : ', this.me)
    if (this.me !== null && this.me !== undefined) {
      //this.$router.push('/applicantDashboard').catch(() => {});
    }
  },
  watch: {
    me (value) {
      console.log('Me computed value: ', value)
      console.log('Me computed: ', this.me)
      if (this.me !== null && this.me !== undefined) {
        if (this.me.ekyc.status == 1 || this.me.ekyc.status == 2) {
          this.$router.push('/applicantInfo').catch(() => {
          })
        } else {
          this.$router.push('/applicantDashboard').catch(() => {
          })
        }
      }
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.mobileNo !== '' && this.password !== ''
    }
  },
  methods: {
    async loginUser () {
      this.loading = true
      this.$vs.loading({
        color: this.colorLoading,
        container: '#button-with-loading',
        scale: 0.45
      })
      await this.$apollo.mutate({
        mutation: login,
        variables: {
          phone: this.mobileNo,
          password: this.password
        }
      }).then((data) => {
        console.log('Login', data)
        if (data.data.login == null) {
          this.msg = 'Invalid User'

          function getRandomInt (min, max) {
            return Math.floor(Math.random() * (max - min)) + min
          }

          let color = `rgb(${getRandomInt(0, 255)},${getRandomInt(0, 255)},${getRandomInt(0, 255)})`
          this.$vs.notify({
            title: 'Error!',
            text: 'Please Enter Registered Mobile No or Password !',
            color: 'danger',
            position: 'top-right'
          })
        } else {
          this.$store.dispatch('userToken', data.data.login)
          onLogin(this.$apollo.provider.defaultClient, data.data.login)
          console.log('Meeeee', this.me)

          function getRandomInt (min, max) {
            return Math.floor(Math.random() * (max - min)) + min
          }

          let color = `rgb(${getRandomInt(0, 255)},${getRandomInt(0, 255)},${getRandomInt(0, 255)})`
          this.$vs.notify({
            title: 'Log In',
            text: 'Logged in Successfully.',
            color: 'success',
            position: 'top-right'
          })
        }
        this.$vs.loading.close('#button-with-loading > .con-vs-loading')
        this.loading = false
      }).catch((error) => {
        this.loading = false
        this.$vs.loading.close('#button-with-loading > .con-vs-loading')
        this.$vs.notify({
          title: 'Log In Error',
          text: 'Invalid user or password.',
          color: 'danger',
          position: 'top-right'
        })
      })
    },
    onlyNumber ($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault()
      }
    },
    /*registerUser () {
      this.$router.push('/pages/register').catch(() => {
      })
    }*/
  }
}


</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
img.mx-auto.login-img {
  /*width: 100%;*/

}
</style>
